import Rails from "@rails/ujs";
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleUserTaskDelete(event) {
    $(`#include-users`).toggle();
    $(`#exclude-users`).toggle();
  }
}
